module.exports = __webpack_public_path__ + "static/img/合约交易-服务支持.89b3dd1a.png";